import { observable } from "@legendapp/state";

// Use this store for values that should remain available for the
// duration of the app's session.
const AppStore$ = observable({
  allAdvertisers: {},
  allAgencies: {},
  allOrgs: {},
  isAdvertisersStreaming: false,
  isAgenciesStreaming: false,
  isOrgsStreaming: false,
});

export default AppStore$;
